import appendToSearchParams from 'Common/Utils/appendToSearchParams';
import { getResource } from 'Common/Utils/apiHelpers';

const baseUrl = '/api/v2';

async function fetchAppointeeResponses(year, grouping, types, teamIds, errorCallback) {
    const groupingEncoded = encodeURIComponent(grouping);
	const query = new URLSearchParams();
	appendToSearchParams(query, 'types', types);
	appendToSearchParams(query, 'teamIds', teamIds);
    appendToSearchParams(query, 'readyForApproval', 'Issued');
	const url = `${baseUrl}/appointments/appointments/${year}/${groupingEncoded}?${query.toString()}`;

    return getResource(url, errorCallback);
}

export { fetchAppointeeResponses };